import { useForm } from "react-hook-form";
import ModalTemplate from "../templates/ModalTemplate";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useSendEmailMutation } from "../../app/api";
import Button from "../atoms/Button";

type ContactUsModalProps = {
  open: boolean;
  onClose: () => void;
  bookingId: number;
  type?: string;
  fontClass?: string;
  stylingType?: "events_styling" | "booking_proposal_styling";
};

function ContactUsModal({
  open,
  onClose,
  bookingId,
  type,
  fontClass,
  stylingType = "events_styling",
}: ContactUsModalProps) {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    values: {
      content: "",
      subject: "",
    },
  });
  const [sendEmail] = useSendEmailMutation();

  const submitSendEmail = () => {
    const values = getValues();

    try {
      sendEmail({ ...values, id: bookingId, type: type });
    } finally {
      setValue("content", "");
      setValue("subject", "");
      onClose();
    }
  };

  return (
    <ModalTemplate
      open={open}
      handleClose={onClose}
      className={fontClass || "font-roboto"}
    >
      <div className="p-2 flex flex-row justify-between items-center bg-[#FAFAFA] min-w-96">
        <span className={`font-semibold text-2xl`}>
          {globalThis.translate.em.proposal.contact_modal.title}
        </span>
        <IconButton onClick={onClose} className="h-8 w-8">
          <CloseIcon />
        </IconButton>
      </div>
      <form onSubmit={handleSubmit(submitSendEmail)}>
        <div className="p-2">
          <label className={`block text-sm font-medium text-gray-700 `}>
            {globalThis.translate.em.proposal.contact_modal.label.subject}
          </label>
          <input
            type="text"
            {...register("subject", { required: true })}
            className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm `}
          />
          {errors.subject && (
            <span className={`text-red-500 `}>
              {globalThis.translate.em.proposal.contact_modal.required.subject}
            </span>
          )}
        </div>
        <div className="p-2">
          <label className={`block text-sm font-medium text-gray-700 `}>
            {globalThis.translate.em.proposal.contact_modal.label.content}
          </label>
          <textarea
            rows={5}
            {...register("content", { required: true })}
            className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm `}
          />
          {errors.content && (
            <span className={`text-red-500 `}>
              {globalThis.translate.em.proposal.contact_modal.required.content}
            </span>
          )}
        </div>
        <div className="bg-[#FAFAFA] flex gap-1 rounded">
          <div className="flex flex-row justify-end items-center w-full gap-2 px-4 py-4">
            <button
              onClick={onClose}
              className={`py-[6px] px-6 rounded font-semibold text-[18px] `}
            >
              {globalThis.translate.em.proposal.contact_modal.cancel}
            </button>
            <Button
              type="submit"
              className={`bg-[#BF5934] py-[6px] px-6 rounded text-white font-semibold text-[18px]`}
              stylingType={stylingType}
            >
              {globalThis.translate.em.proposal.contact_modal.send}
            </Button>
          </div>
        </div>
      </form>
    </ModalTemplate>
  );
}

export default ContactUsModal;
